import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { isAddress } from 'web3-validator';

const PurchaseModal = ({
                           show,
                           onHide,
                           walletAddress,
                           onAddressChange,
                           connectMetaMask,
                           onContinue,
                           email,
                           onEmailChange,
                           giftMessage,
                           ongiftMessageChange
                       }) => {
    const [isButtonDisabled, setIsButtonDisabled] = useState(true)
    const isValidEmail = (email) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const isFormValid = () => {
        return isValidEmail(email) && isAddress(walletAddress);
    };

    // Recheck validity whenever email, walletAddress changes
    useEffect(() => {
        setIsButtonDisabled(!isFormValid());
    }, [email, walletAddress]);

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Enter Web3 Address</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control
                            type="email"
                            value={email}
                            placeholder="Enter your email address"
                            onChange={onEmailChange}
                            required
                            isInvalid={!isValidEmail(email) && email !== ""}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please enter a valid email address.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mt-3 ">
                        <Form.Label className="me-3">Web3 Address</Form.Label>
                        <div className="d-flex align-items-center">
                            <Form.Control
                                type="text"
                                value={walletAddress}
                                placeholder="Enter your Web3 address"
                                onChange={onAddressChange}
                                required
                                isInvalid={!isAddress(walletAddress) && walletAddress !== ""}
                                className="me-2"
                                style={{ flex: 1 }}
                            />
                            <Button variant="secondary" onClick={connectMetaMask}>
                                Import from MetaMask
                            </Button>
                        </div>
                        <Form.Control.Feedback type="invalid">
                            Web3 address cannot be empty.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mt-3">
                        <Form.Label>Gift Message (Optional)</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter a message if this is a gift"
                            value={giftMessage}
                            onChange={ongiftMessageChange}
                        />
                    </Form.Group>

                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={() => onContinue(giftMessage)}
                    disabled={isButtonDisabled}
                    style={{ backgroundColor: isButtonDisabled ? "#d3d3d3" : "" }}
                >
                    Continue
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PurchaseModal;
